import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ImgContainFit, ImgCover, ImgWH } from '@pages/CommonStyle/common.style';

export const RecommendProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); // 한 줄에 2개
  gap: 32px;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    padding-bottom: 24px;

    gap: 32px;
    & > div {
      scroll-snap-align: start;
      flex: 0 0 auto;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const RecommendProductSection = styled.div`
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: column;
    gap: 0px;
    width: 300px;
  }
`;

export const RecommendProductImg = styled.img`
  object-fit: cover;
  width: 100%;
`;

export const RecommendProductTextBox = styled.div`
  padding: 24px 24px 0px 24px;
  background-color: #f8f8f8;
`;

export const RecommendProductMore = styled.div`
  padding: 16px 32px;
  border: 1px solid #000;
  border-radius: 12px;
  text-align: center;
  width: 200px;

  &:hover {
    cursor: pointer;
  }
`;
